export default __webpack_public_path__ + "static/media/10.8e04bd8e.jpg";